import axios from '../../axios'

// 查询
export const getUserInfo = data => {
    return axios({
        url: '/api/admin/abroad/user',
        method: 'post',
        data: data
    })
}

// 用户日志查询
export const getUserLogList = data => {
    return axios({
        url: '/api/user/abroad/access/log/oauth/page',
        method: 'get',
        data: data
    })
}

// 用户日志查询
export const getUserInfoLog = data => {
    return axios({
        url: '/api/user/abroad/access/log/page',
        method: 'get',
        data: data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/adroad/user.js